import apiService from './api';

const nursingTestCatalogService = {
  getTypes() {
    return apiService.get('/nursing-test-catalog/types');
  },

  list(params = {}) {
    return apiService.get('/nursing-test-catalog', { params });
  },

  getById(id) {
    return apiService.get(`/nursing-test-catalog/${id}`);
  },

  create(payload) {
    return apiService.post('/nursing-test-catalog', payload);
  },

  update(id, payload) {
    return apiService.put(`/nursing-test-catalog/${id}`, payload);
  },

  remove(id) {
    return apiService.delete(`/nursing-test-catalog/${id}`);
  }
};

export default nursingTestCatalogService;
